import type { TypedMyHotelLucyPromises } from './-MyHotelLucyPromises';
import RawMyHotelLucyPromises from './-MyHotelLucyPromises.vue';
export * from './-MyHotelLucyPromises';
export const MyHotelLucyPromises = RawMyHotelLucyPromises as typeof TypedMyHotelLucyPromises;
